import { createRootRoute, Outlet } from '@tanstack/react-router';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';

import { GoogleAnalyticsPageviewTracker } from '@/components/common/google-analytics-pageview-tracker';
import { NotFound } from '@/components/common/not-found';
import { PassiveAuthLoginTrigger } from '@/components/common/passive-auth-login-trigger';
import { PostHogPageviewTracker } from '@/components/common/posthog-pageview-tracker';
import { RouteError } from '@/components/common/route-error';

export const Route = createRootRoute({
    component: RootComponent,
    notFoundComponent: NotFound,
    errorComponent: ({ error }) => <RouteError error={error} />
});

function RootComponent() {
    return (
        <>
            <GoogleAnalyticsPageviewTracker />
            <PostHogPageviewTracker />
            <PassiveAuthLoginTrigger />
            <Outlet />
            <Toaster position='bottom-right' richColors closeButton />
            <ReactQueryDevtools buttonPosition='bottom-left' />
        </>
    );
}
